import { render } from "./BIBO_ENDORSERS.vue?vue&type=template&id=8a30e050"
import script from "./BIBO_ENDORSERS.vue?vue&type=script&lang=ts"
export * from "./BIBO_ENDORSERS.vue?vue&type=script&lang=ts"
script.render = render

export default script